import DMBLogo from '../assets/images/logo/LogoDMB.png'
import DMB1 from '../assets/images/thumbnails/EP1.jpg'
import DMB2 from '../assets/images/thumbnails/EP2.jpg'
import DMB3 from '../assets/images/thumbnails/EP3.jpg'
import DMB4 from '../assets/images/thumbnails/EP4.jpg'
import DMB5 from '../assets/images/thumbnails/EP5.jpg'
import DMB6 from '../assets/images/thumbnails/EP6.jpg'
import DMB7 from '../assets/images/thumbnails/EP7.jpg'
import DMB8 from '../assets/images/thumbnails/EP8.jpg'
import DMB85 from '../assets/images/thumbnails/EP8.5.png'
import DMB105 from '../assets/images/thumbnails/EP10.5.jpg'
import DMB9 from '../assets/images/thumbnails/EP9.jpg'
import DMB10 from '../assets/images/thumbnails/EP10.jpg'
import DMB11 from '../assets/images/thumbnails/EP11.jpg'
import DMB12 from '../assets/images/thumbnails/EP12.jpg'
import DMB125 from '../assets/images/thumbnails/DMB125.png'
import DMBP1 from '../assets/images/preview/DMBP1.png'
import DMBP2 from '../assets/images/preview/DMBP2.png'
import DMBP3 from '../assets/images/preview/DMBP3.png'
import DMBP4 from '../assets/images/preview/DMBP4.png'
import DMBP5 from '../assets/images/preview/DMBP5.png'
import DMBP6 from '../assets/images/preview/DMBP6.png'
import DMBP7 from '../assets/images/preview/DMBP7.png'
import DMBP8 from '../assets/images/preview/DMBP8.png'
import DMBP9 from '../assets/images/preview/DMBP9.png'
import DMBP10 from '../assets/images/preview/DMBP10.png'
import DMBP11 from '../assets/images/preview/DMBP11.png'
import DMBP12 from '../assets/images/preview/DMBP12.png'
import DMBP85 from '../assets/images/preview/DMBP8.5.png'
import DMBP105 from '../assets/images/preview/DMBP10.5.png'
import DMBP125 from '../assets/images/preview/DMBP125.png'
import DMB13 from '../assets/images/thumbnails/EP13.png'
import DMBP13 from '../assets/images/preview/DMB13P.png'



const DMB = [
  {
    id: 1,
    section: 'DMB',
    title: 'Episodio 1 : Un Nuevo Plan',
    thumbnailUrl: DMB1,
    webUrl: 'https://www.youtube.com/embed/TZijjc32tkw',
    backgroundImage: DMBP1,
    seriesLogo: DMBLogo,
    description: 'El epico desmadre comienza!',
  },
  {
    id: 2,
    section: 'DMB',
    title: 'Episodio 2 : Sendero al Mal',
    thumbnailUrl: DMB2,
    webUrl: 'https://www.youtube.com/embed/mB9anl-5yVw',
    backgroundImage: DMBP2,
    seriesLogo: DMBLogo,
    description: 'Mario y Luigi se aventuran al castillo de Bowser para salvar a la princesa Peach.',
  },
  {
    id: 3,
    section: 'DMB',
    title: 'Episodio 3 : El Castillo de Bowser',
    thumbnailUrl: DMB3,
    webUrl: 'https://www.youtube.com/embed/8dEokaQOw4A', // Add the episode URL
    backgroundImage: DMBP3,
    seriesLogo: DMBLogo,
    description: 'Mario y Luigi se enfrentan al castillo de Bowser!',
  },
  {
    id: 4,
    section: 'DMB',
    title: 'Episodio 4 : El Sabio Washatumorra',
    thumbnailUrl: DMB4,
    webUrl: 'https://www.youtube.com/embed/orctsFMh_QA', // Add the episode URL
    backgroundImage: DMBP4,
    seriesLogo: DMBLogo,
    description: 'Los heroes van con el sabio del Reino Champiñón a pedir ayuda.',
  },
  {
    id: 5,
    section: 'DMB',
    title: 'Episodio 5 : Una Nueva Esperanza',
    thumbnailUrl: DMB5,
    webUrl: 'https://www.youtube.com/embed/EH6UmAq498Q', // Add the episode URL
    backgroundImage: DMBP5,
    seriesLogo: DMBLogo,
    description: 'Los heroes se dirijen al Castillo de Peach en busca de una de las únicas cosas que pueden vencer a Bowser.',
  },
  {
    id: 6,
    section: 'DMB',
    title: 'Episodio 6 : ¿El Juego del Miedo?...',
    thumbnailUrl: DMB6,
    webUrl: 'https://www.youtube.com/embed/-EF_khClTVs', // Add the episode URL
    backgroundImage: DMBP6,
    seriesLogo: DMBLogo,
    description: 'Antes de poder conseguir la esfera sagrada deben superar un reto.',
  },
  {
    id: 7,
    section: 'DMB',
    title: 'Episodio 7 : Un Mientras Tanto con Bowser',
    thumbnailUrl: DMB7,
    webUrl: 'https://www.youtube.com/embed/rtMC_l46QSs', // Add the episode URL
    backgroundImage: DMBP7,
    seriesLogo: DMBLogo,
    description: 'Vemos lo que ocurre con Bowser mientras los héroes buscan la segunda esfera sagrada.',
  },
  {
    id: 8,
    section: 'DMB',
    title: 'Episodio 8 : El Club de Comedia',
    thumbnailUrl: DMB8,
    webUrl: 'https://www.youtube.com/embed/tAyD8nioOd4', // Add the episode URL
    backgroundImage: DMBP8,
    seriesLogo: DMBLogo,
    description: 'Los héroes llegan al club de comedia Bickolt y encuentran al hijo del sabio.',
  },
  {
    id: 9,
    section: 'DMB',
    title: 'Dúper Mario Bros - Episodio 8.5 (Escena Eliminada)',
    thumbnailUrl: DMB85,
    webUrl: 'https://www.youtube.com/embed/53vVHDTD-qU', // Add the episode URL
    backgroundImage: DMBP85,
    seriesLogo: DMBLogo,
    description: 'Recuerden que esto no es el resultado final, aún hay cosas que se van a ajustar (como el uso de groserías), la forma de grabar, etc. Recuerden que esta continuación es para todos y si tienen sugerencias, estas se van a recibir y usar para entregar un mejor producto ya cuando más importe, en el Episodio 12 Pt. 2. Vean esto como un video para probar las aguas.',
  },
  {
    id: 10,
    section: 'DMB',
    title: 'Episodio 9 : La Posesión',
    thumbnailUrl: DMB9,
    webUrl: 'https://www.youtube.com/embed/umJg0OmZjno', // Add the episode URL
    backgroundImage: DMBP9,
    seriesLogo: DMBLogo,
    description: '¿Que sera de Mario?... ',
  },
  {
    id: 11,
    section: 'DMB',
    title: 'Episodio 10 : La Hora de Brillar de Luigi',
    thumbnailUrl: DMB10,
    webUrl: 'https://www.youtube.com/embed/zUj9pT_xyLY', 
    backgroundImage: DMBP10,
    seriesLogo: DMBLogo,
    description: 'Los heroes se adentran en el Templo Sagrado para poder salvar a Mario. ',
  },
  {
    id: 12,
    section: 'DMB',
    title: 'Episodio 10.5 : La Hora de Brillar del Vendedor',
    thumbnailUrl: DMB105,
    webUrl: 'https://www.youtube.com/embed/ZkRgXgmqemM', // Add the episode URL
    backgroundImage: DMBP105,
    seriesLogo: DMBLogo,
    description: 'El vendedor regresa!! y esta vez tiene un nuevo trabajo en el restaurante "EL ITALIANO". No se pierdan esta extención de episodio este 25 de Diciembre!!',
  },
  {
    id: 13,
    section: 'DMB',
    title: 'Episodio 11 : El Shadowken',
    thumbnailUrl: DMB11,
    webUrl: 'https://www.youtube.com/embed/Mvk5t1jL1Nw', // Add the episode URL
    backgroundImage: DMBP11,
    seriesLogo: DMBLogo,
    description: 'Soul tiene otros planes, ¿podrán los héroes detenerlo?',
  },
  {
    id: 14,
    section: 'DMB',
    title: 'UNA PARTE DEL Episodio 12',
    thumbnailUrl: DMB12,
    webUrl: 'https://www.youtube.com/embed/jlIA9Q58Sxs', // Add the episode URL
    backgroundImage: DMBP12,
    seriesLogo: DMBLogo,
    description: 'La cuenta regresiva empieza. ¿Qué harán nuestros héroes para vencer a Soul?',
  },
  {
    id: 15,
    section: 'DMB',
    title: 'LA OTRA PARTE DEL Episodio 12 : Una Nueva Misión',
    thumbnailUrl: DMB125,
    webUrl: 'https://www.youtube.com/embed/NIDoa2Rprk0', // Add the episode URL
    backgroundImage: DMBP125,
    seriesLogo: DMBLogo,
    description: 'Nuestros heroes siguen su meta de conseguir las esferas sagradas. Pero se encontrarán con viejos y nuevos retos en su camino al siguiente destino...',
  },
  {
    id: 16,
    section: 'DMB',
    title: 'Episodio 13 : La Torre Sagrada',
    thumbnailUrl: DMB13,
    webUrl: 'https://www.youtube.com/embed/FhmlbyZYCqg', // Add the episode URL
    backgroundImage: DMBP13,
    seriesLogo: DMBLogo,
    description: '¡Johnny está en peligro! Separado del grupo, Toad tropieza con una persona familiar. Mientras tanto, los errores del pasado asechan a Mario, y nuestros heroes se enfrentan a un dilema que pondrá a prueba su lealtad. ¿Hasta dónde están dispuestos a llegar por las esferas sagradas?',
  },
  ];

  export default DMB;




 

